import React, { Component } from "react";

import { BulkPackagingContextProvider } from "./context/bulk-packaging-context";
import AsyncComponent from "../../../components/async-component";
import { updateBreadcrumb } from "../../../utils/breadcrumbs";
import PageContent from "../../../components/page-content";
import PageWrap from "../../../components/page-wrap";

class BSBulkPackaging extends Component {
    componentDidMount = updateBreadcrumb;

    render() {
        return (
            <PageWrap>
                <PageContent>
                    <BulkPackagingContextProvider>
                        <AsyncComponent component={() => import("./content")} />
                    </BulkPackagingContextProvider>
                </PageContent>
            </PageWrap>
        );
    }
}

export default BSBulkPackaging;
